import { createAction } from '../../../../../store.model';
import { ActionType } from '../teamschat-transcript-dialog.action';

export interface EditNotesFocus {
    behaviourId: number;
    subBehaviourId: number;
}

export const editNotesFocus = createAction<ActionType, EditNotesFocus>(
    ActionType.COACHING_DETAIL__TCTD__EDIT_NOTES_FOCUS,
);
